<template>
    <div>
        <Topbar title="Basic converter keymap" />
        <Sidebar />
        <Main>
            <br />
            <div class="container">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h2>স্বরবর্ণ</h2>
                    </div>
                    <div class="panel-body">
                        <table class="table table-striped">
                            <thead>
                                <tr><th>যা লিখতে হবে</th><th>আউটপুট যা পাওয়া যাবে</th></tr>
                            </thead>
                            <tbody>
                                <tr><td>A</td><td>অ</td></tr>
                                <tr><td>a</td><td>আ</td></tr>
                                <tr><td>i</td><td>ই</td></tr>
                                <tr><td>ii/ee/I</td><td>ঈ</td></tr>
                                <tr><td>u</td><td>উ</td></tr>
                                <tr><td>uu/U</td><td>ঊ</td></tr>
                                <tr><td>rri/q</td><td>ঋ</td></tr>
                                <tr><td>e</td><td>এ</td></tr>
                                <tr><td>E/OI</td><td>ঐ</td></tr>
                                <tr><td>o/w</td><td>ও</td></tr>
                                <tr><td>O/OU</td><td>ঔ</td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h2>স্বরবর্ণের সংক্ষিপ্ত রূপ(কার)</h2>
                    </div>
                    <div class="panel-body">
                        <table class="table table-striped">
                            <thead>
                                <tr><th>যা লিখতে হবে</th><th>আউটপুট যা পাওয়া যাবে</th></tr>
                            </thead>
                            <tbody>
                                <tr><td>a</td><td>া</td></tr>
                                <tr><td>i</td><td>ি</td></tr>
                                <tr><td>ii/ee/I</td><td>ী</td></tr>
                                <tr><td>u</td><td>ু</td></tr>
                                <tr><td>uu/U</td><td>ূ</td></tr>
                                <tr><td>rri/q</td><td>ৃ</td></tr>
                                <tr><td>e</td><td>ে</td></tr>
                                <tr><td>E/OI</td><td>ৈ</td></tr>
                                <tr><td>o</td><td>ো</td></tr>
                                <tr><td>O/OU</td><td>ৌ</td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h2>ব্যঞ্জনবর্ণ</h2>
                    </div>
                    <div class="panel-body">
                        <table class="table table-striped">
                            <thead>
                                <tr><th>যা লিখতে হবে</th><th>আউটপুট যা পাওয়া যাবে</th></tr>
                            </thead>
                            <tbody>
                                <tr><td>k</td><td>ক</td></tr>
                                <tr><td>kh<td>খ</td></tr>
                                <tr><td>g<td>গ</td></tr>
                                <tr><td>gh<td>ঘ</td></tr>
                                <tr><td>Ng/G<td>ঙ</td></tr>
                                <tr><td>c<td>চ</td></tr>
                                <tr><td>ch<td>ছ</td></tr>
                                <tr><td>j<td>জ</td></tr>
                                <tr><td>jh<td>ঝ</td></tr>
                                <tr><td>NG/J<td>ঞ</td></tr>
                                <tr><td>T<td>ট</td></tr>
                                <tr><td>Th<td>ঠ</td></tr>
                                <tr><td>D<td>ড</td></tr>
                                <tr><td>Dh<td>ঢ</td></tr>
                                <tr><td>N<td>ণ</td></tr>
                                <tr><td>t<td>ত</td></tr>
                                <tr><td>th<td>থ</td></tr>
                                <tr><td>d<td>দ</td></tr>
                                <tr><td>dh<td>ধ</td></tr>
                                <tr><td>n<td>ন</td></tr>
                                <tr><td>p<td>প</td></tr>
                                <tr><td>f/ph<td>ফ</td></tr>
                                <tr><td>b<td>ব</td></tr>
                                <tr><td>bh/v<td>ভ</td></tr>
                                <tr><td>m<td>ম</td></tr>
                                <tr><td>z<td>য</td></tr>
                                <tr><td>r<td>র</td></tr>
                                <tr><td>l<td>ল</td></tr>
                                <tr><td>sh<td>শ</td></tr>
                                <tr><td>S<td>ষ</td></tr>
                                <tr><td>s<td>স</td></tr>
                                <tr><td>h/H<td>হ</td></tr>
                                <tr><td>R<td>ড়</td></tr>
                                <tr><td>Rh<td>ঢ়</td></tr>
                                <tr><td>y<td>য়</td></tr>
                                <tr><td>tt<td>ৎ</td></tr>
                                <tr><td>ng<td>ং</td></tr>
                                <tr><td>:<td>ঃ</td></tr>
                                <tr><td>C</td><td>ঁ</td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h2>এবং...</h2>
                    </div>
                    <div class="panel-body">
                        <table class="table table-striped">
                            <thead>
                                <tr><th>যা লিখতে হবে</th><th>আউটপুট যা পাওয়া যাবে</th></tr>
                            </thead>
                            <tbody>
                                <tr><td>". "(ফুলস্টপ স্পেস)</td><td>"। "(দাঁড়ি স্পেস)</td></tr>
                                <tr><td>k.S</td><td>ক্ষ</td></tr>
                                <tr><td>x/k.s</td><td>ক্স</td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h2>যুক্ত বর্ণের নিয়ম</h2>
                    </div>
                    <div class="panel-body">

                        যে দুইটি বর্ণ যুক্ত করতে চান সেই দুইটি বর্ণের মাঝে ফুলস্টপ(.) ব্যাবহার করুন।
                        যেমনঃ বৃষ্টি=brriS.Ti
                        স্কুল=s.kul
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading"><h2>ফলার নিয়ম</h2></div>
                    <div class="panel-body">
                        <b>ব-ফলা ব্যাবহার করতেঃ </b> ".b"<br /> যেমনঃ লম্বা=lm.ba<br />জিহ্বা=jih.ba<br /><br /><b>য ফলা ব্যাবহার করতেঃ</b>".z"<br />
                        যেমনঃ সাহায্য=sahaz.z
                        বাল্য=bal.z<br/><br/>
                        <b>রেফ ব্যাবহার করতেঃ</b> "r."<br />
                        যেমনঃ ফার্স্ট=far.s.T<br/>মূর্খ=muur.kh/mUr.kh
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h2>লক্ষ্য করুন</h2>
                    </div>
                    <div class="panel-body">
                        "ক" "গ" "চ" "জ" "প" "ব" "স" "ত" "ট" "দ""ড"-এই বর্ণ গুলোর পর "হ" লিখতে চাইলে "H"(বড় হাতের) ব্যবহার করুন
                    </div>
                </div>

                <div class="panel panel-default">
                    <div class="panel-heading"><h2>বিশেষ নিয়ম</h2></div>
                    <div class="panel-body">
                        র এ য-ফলা(র‍্য) ব্যাবহার করতে ফুলস্টপ(.) ব্যাবহার করা যাবে না। করলে তা "র্য" হয়ে যাবে। "র‍্য" লিখতে "rz" ব্যাবহার করতে হবে। যেমনঃ র‍্যালি=rzali ,র‍্যাপ=rzap,র‍্যাপিড=rzapiD
                    </div>
                </div>
            </div>
        </Main>
    </div>
</template>

<script>
import Topbar from '../components/Topbar';
import Sidebar from '../components/Sidebar';
import Main from '../components/Main';
export default {
    name: 'BasicKeymap',
    components: { Main, Sidebar, Topbar }
};
</script>
